module.exports = __webpack_public_path__ + "img/process1.7bce546c.png";